import { simpleSet } from '@r/reducers/utils';

const sForVisible = simpleSet as redux.reducers.modals.modalFor2dVisible;

export const modalFor2dVisible =
  sForVisible( 'SET_MODAL_FOR_2D_VISIBLE', false );
